// extracted by mini-css-extract-plugin
export default {"list":"list-module--list--1yStT","item":"list-module--item--3QlsQ","bullet":"list-module--bullet--34xQb","title":"list-module--title--34zND","link":"list-module--link--29yrf"};